import { Create, SimpleForm, TextInput, SelectInput } from "react-admin";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

const typeChoices = [
  { id: "AUTHOR", name: "Author" },
  { id: "SUPERVISOR", name: "Supervisor" },
];

const FullNameUpdater = () => {
  const { watch, setValue } = useFormContext();
  const lastName = watch("lastName");
  const firstName = watch("firstName");
  const middleName = watch("middleName");

  useEffect(() => {
    setValue(
      "fullName",
      `${lastName || ""} ${firstName || ""} ${middleName || ""}`.trim()
    );
  }, [lastName, firstName, middleName, setValue]);

  return null;
};

export const PersonCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="code" />
      <SelectInput source="type" choices={typeChoices} />
      <TextInput source="lastName" />
      <TextInput source="firstName" />
      <TextInput source="middleName" />
      <FullNameUpdater />
      <TextInput source="fullName" />
    </SimpleForm>
  </Create>
);
